/**
 * Created by lenovo on 2017/9/29.
 */
import axios from 'axios';

axios.interceptors.request.use(config =>
  // loading
  config, error => Promise.reject(error));

axios.interceptors.response.use(response => response, error => Promise.resolve(error.response));

function checkStatus(response) {
  // loading
  // 如果http状态码正常，则直接返回数据
  if (response && response.data && (response.data.code === 200 || response.data.code === 304)) {
    return response.data;
    // 如果不需要除了data之外的数据，可以直接 return response.data
  }
  // 异常状态下，把错误信息返回去
  return response;
}

function checkCode(res) {
  // 如果resCode异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
  if (res.resCode === '500' || res.resCode === '403') {
    // alert(res.message)
  }
  if (res.data && (!res.data.success)) {
    // alert(res.data.error_msg)
  }
  return res;
}

export default {

  post(url, params) {
    console.log(params, 'params');
    let sign = params;
    let paramsrrr;
    if (params) {
      const secret = 'KH2J9PC326T44D439H6VTVPBY';//秘钥
      //请求参数
      // var param = { "Type": 3, "PageRow": 10 };
      const keyParam = Object.keys(params).sort();//针对Key进行字典顺序排列
      console.log(keyParam, 'keyParam');
      let sParam = '';
      console.log(sParam, 'sParam');
      // let p;
      for (let p = 0; p < keyParam.length;p++) {
          if(params[keyParam[p]] !== ''){
              sParam += keyParam[p] + '=' + params[keyParam[p]];
          }
      }//拼接参数密文
      console.log(sParam, 'sParam');
      if (!!window.$) {
        sign = $.md5(sParam + secret);//加密
      } else {
        sign = window.md5(sParam + secret);//加密
      }
      params['Sign'] = sign;//拼接签名
      console.log(sign, 'sign');
      console.log(params, 'params');
      paramsrrr = params;
    }
    return axios({
      method: 'post',
      url,
      // params,
      data: paramsrrr,
      // sign,
      timeout: 10000,
      withCredentials: true,
      // contentType: 'application/json;charset=UTF-8',
      // contentType: 'application/x-www-form-urlencoded;charset=UTF-8'
      headers: {'Content-Type': 'application/x-www-form-urlencoded'},
      transformRequest: [function (data) {
        // Do whatever you want to transform the data
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        ret = ret.substr(0, ret.length - 1);
        return ret
      }],
    }).then(response => checkStatus(response)).catch(res => checkCode(res));
  },

  get(url, params) {
    let sign = params;
    if (params) {
      const secret = 'KH2J9PC326T44D439H6VTVPBY';//秘钥
      //请求参数
      // var param = { "Type": 3, "PageRow": 10 };
      const keyParam = Object.keys(params).sort();//针对Key进行字典顺序排列
      let sParam = '';
      for (let p = 0; p < keyParam.length;p++) {
        if(params[keyParam[p]] !== ''){
            sParam += keyParam[p] + '=' + params[keyParam[p]];
        }

        // console.log(sParam, 'sParam');
        // console.log(params, 'params');
        // console.log(p, 'p');
      }//拼接参数密文
      sign = window.md5(sParam + secret);//加密
      params['Sign'] = sign;//拼接签名
      console.log(params, 'params');
    }
    return axios({
      method: 'get',
      url,
      params, // get 请求时带的参数
      // sign,
      timeout: 10000
    }).then(response => checkStatus(response)).catch(res => checkCode(res));
  }
};



// WEBPACK FOOTER //
// ./src/api/CommonHttp.js